import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_ADMISSION_TYPE_LIST = "GET_ADMISSION_TYPE_LIST";

export const service = async () => {
  const options: object = {
    url: "/api/AdmissionType/GetAdmissionType",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ADMISSION_TYPE_LIST, service, mock);
